// extracted by mini-css-extract-plugin
export var content = "_6p-3";
export var list = "_6p-4";
export var settingsContent = "_6p-7";
export var settingsPanel = "_6p-8";
export var state = "_6p-6";
export var triggerBadge = "_6p-2";
export var triggerButton = "_6p-1";
export var triggerShell = "_6p-0";
export var unreadDot = "_6p-5";